
export const a4suits = [
    'spades', // ♠
    'hearts', // ♥
    'diamonds', // ♦
    'clubs', // ♣
];

// 2最小 - A最大，越大越有优势 
const a13Cards = [
    '2', '3', '4', '5', '6', '7', '8', '9', '10',
    'J', 'Q', 'K', 'A', // 字母部分 
];

// 一副扑克
// 示例 spades2, hearts2, diamonds2, clubs2, spades3, hearts3, diamonds3, clubs3, spades4... 
export const aAllCards = a13Cards.flatMap((sNumber)=>{
    return [
        a4suits[0] + sNumber,
        a4suits[1] + sNumber,
        a4suits[2] + sNumber,
        a4suits[3] + sNumber,
    ];
});

// console.log('aAllCards', aAllCards);

// const oNumber2Letter = {
//     '1': 'A',
//     '11': 'J',
//     '12': 'Q',
//     '13': 'K',
// };

// const aPokerIntList = Array(13).fill(1).flatMap((cur, idx)=>{
//     const no = idx + 1;
//     return [
//         '♠'+no,
//         '♥'+no,
//         '♣'+no,
//         '♦'+no,
//     ];
// });

// const aPokerList = aPokerIntList.map((cur, idx)=>{
//     const letter = oNumber2Letter[cur.slice(1)];
//     if (letter) return cur[0] + letter;
//     return cur; 
// });

// ↓ 头部插入空值，重要
// aPokerIntList.unshift(''); 
// aPokerList.unshift('');

// console.log('aPokerIntList', aPokerIntList);
// console.log('aPokerList', aPokerList);

// export {
//     aPokerIntList,
//     aPokerList,
// }
